import RechargeLog from '@/pages/recharge/rechargeLog'
import StorageLog from '@/pages/recharge/rechargeLog/storageLog'
import Postpone from '@/pages/recharge/rechargeLog/postpone'

export default [
  {
    path: '/rechargeLog',
    name: 'RechargeLog',
    component: RechargeLog,
    meta: { name: '短信充值' }
  },
  {
    path: '/postpone',
    name: 'Postpone',
    component: Postpone,
    meta: { name: '延期记录' }
  },
  {
    path: '/storageLog',
    name: 'StorageLog',
    component: StorageLog,
    meta: { name: '存储充值' }
  },
]



// WEBPACK FOOTER //
// ./src/router/recharge/rechargeLog.js